import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

// component
import WrapperSettingPage from "../component/WrapperSettingPage";

// helpers
import { getJsonFromUrl } from "helpers";

// actions
import * as Actions from "actions";

const mapStateToProps = (state) => ({
  settings: state.settings,
  templates: state.templates,
});

const mapDispatchToProps = (dispatch) => ({
  getSettings: () => dispatch(Actions.getSettings()),
  getSettingById: (...args) => dispatch(Actions.getSettingById(...args)),
  createSetting: (...args) => dispatch(Actions.createSetting(...args)),
  deleteSetting: (...args) => dispatch(Actions.deleteSetting(...args)),
  updateSetting: (...args) => dispatch(Actions.updateSetting(...args)),
  getTemplates: (...args) => dispatch(Actions.getTemplates(...args)),
  sendTemplateEmail: (...args) => dispatch(Actions.sendTemplateEmail(...args)),
});
class SettingPage extends Component {
  static propTypes = {
    session: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    templates: PropTypes.array,

    settings: PropTypes.array,
    getSettings: PropTypes.func,
    getSettingById: PropTypes.func,
    createSetting: PropTypes.func,
    deleteSetting: PropTypes.func,
    updateSetting: PropTypes.func,
    getTemplates: PropTypes.func,
    sendTemplateEmail: PropTypes.func,
  };

  constructor(...args) {
    super(...args);
    const { location, settings } = this.props;

    this.state = {
      urlParams: getJsonFromUrl(location),
      loading: settings.length === 0,
    };
  }

  componentDidMount() {
    console.log("componentDidMount");
    this.refresh();
  }

  async refresh() {
    const { getSettings, getTemplates } = this.props;
    await Promise.all([getSettings(), getTemplates()]);

    this.setState({ loading: false });
  }

  render() {
    const {
      history,
      settings,
      getSettingById,
      createSetting,
      deleteSetting,
      updateSetting,
      templates,
      sendTemplateEmail,
    } = this.props;

    const { urlParams, loading } = this.state;

    return (
      <WrapperSettingPage
        history={history}
        refresh={this.refresh.bind(this)}
        loading={loading}
        settings={settings}
        templates={templates}
        getSettingById={getSettingById}
        createSetting={createSetting}
        deleteSetting={deleteSetting}
        updateSetting={updateSetting}
        urlParams={urlParams}
        sendTemplateEmail={sendTemplateEmail}
      />
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(SettingPage);
